/* eslint-disable react-hooks/exhaustive-deps */
import React, { useRef, useEffect } from "react";
import { Link, useHistory } from "react-router-dom";
import LoadPanel from "devextreme-react/load-panel";
import { formatMessage } from "devextreme/localization";
import { useDispatch, useSelector } from "react-redux";
import { showDictionary, IsPermisionOidRequired } from "../../../redux/actions";
import {
  responseDictionary,
  responseMiddleware,
} from "../../../redux/reducers";
import DictionaryTableList from "./DictionaryTable";
import UsingIntl from "../../../services/using_intl";

export default function DictionaryPage() {
  let dataGrid = useRef(null);
  const dispatch = useDispatch();
  const history = useHistory();
  const { dictionary } = useSelector(responseDictionary);
  const { middleware, loading } = useSelector(responseMiddleware);

  useEffect(() => {
    dispatch(IsPermisionOidRequired());
    UsingIntl();
  }, [dispatch]);

  useEffect(() => {
    if (middleware) {
      const { NavigateState, ReadState } = middleware;
      if (
        (NavigateState !== undefined && !NavigateState) ||
        (!ReadState && ReadState !== undefined)
      ) {
        history.push("/403");
        return;
      }
    }
  }, [middleware]);

  const handleValueSelectChanged = ({ value }) => {
    dispatch(showDictionary(value));
  };

  return (
    <div>
      <LoadPanel visible={loading} />
      {/* Toast open */}

      {/* Breadcrumb */}
      <div className={"breadcrumb"}>
        <div className={"breadcrumb-left"}>
          <div className={"breadcrumb-page-title"}>
            {formatMessage("DictionaryList")}
          </div>
        </div>
        <div className={"breadcrumb-right"}>
          <Link to="/default" className={"breadcrumb-item"}>
            {formatMessage("Default")}
          </Link>

          <span className={"breadcrumb-item active"}>
            {formatMessage("DictionaryList")}
          </span>
        </div>
      </div>
      <div className={"section"}>
        <div className={"section-body"}>
          {/* Role list */}
          <DictionaryTableList
            dataGrid={dataGrid}
            dataSource={dictionary}
            middleware={middleware}
            onValueChanged={handleValueSelectChanged}
          />
        </div>
      </div>
    </div>
  );
}
